import React, { useEffect, useState, useRef } from "react";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import draftToHtml from "draftjs-to-html";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
  convertFromRaw,
  convertToHTML,
} from "draft-js";
import dropdown from "../../assets/images/dropdown.svg";
import Spinner from "../../components/Spinner";
import Alert from "../../assets/images/alert-circle.svg";
import warning from "../../assets/images/alert-triangle.svg";
import success from "../../assets/images/success.svg";
import circle from "../../assets/images/circle.svg";
import uparrow from "../../assets/images/arrow-up.svg";
import Logo from "../../assets/images/TKC-Logo1.png";
import Info from "../../assets/images/help.svg";
import Video from "../../assets/images/video-thumb.svg";
import Doc from "../../assets/images/doc.svg";
import Closes from "../../assets/images/Close.svg";
import File from "../../assets/images/file.svg";
import Disc from "../../assets/images/round.svg";
import Download from "../../assets/images/download.svg";
import closex from "../../assets/images/X.svg";
import LogoPw from "../../assets/images/Logo.png";

import arrow from "../../assets/images/corner-down-left 1.svg";
import dots from "../../assets/images/more-horizontal.svg";
import { Link, Navigate, useNavigate } from "react-router-dom";
import FillablePdf from "../Onboarding/pdfFiller";

import "../../assets/css/responsive.css";

import close from "../../assets/images/Close.svg";
import { useLocation, useParams } from "react-router-dom";
import { Close } from "@material-ui/icons";
import Down from "../../assets/images/down.svg";
import User from "../../assets/images/User.svg";

import help from "../../assets/images/help.svg";

import logout from "../../assets/images/logout.png";

import setting from "../../assets/images/setting.png";
import right from "../../assets/images/right.svg";
// import { Document, Page } from 'react-pdf'
import pdf from "../../assets/payment.pdf";
// import { pdfjs, Document, Page } from 'react-pdf';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Menu from "../../assets/images/menu.svg";
import caseLogo from "../../assets/images/caselogo.png";

import eye from "../../assets/images/eye.png";
import eyeview from "../../assets/images/view.png";
import Modal from "react-modal";

import moment from "moment";
import FillCandidate from "./FillCandidate";
import W4form from "../legalforms/W4form";
import I9form from "../legalforms/I9form";
import W4South from "../legalforms/W4South";
import OldI9form from "../legalforms/OldI9Form";

const CandidateOnboardingForm = () => {
  const location = useLocation();
  console.log(location);
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [progress, setProgress] = useState(0);
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState([]);
  const [modalData, setModalData] = useState({});
  const [showResetModal, setShowResetModal] = useState(false);
  const [pdfViewer, setPdfViewer] = useState(false);
  const [pdfViewerItem, setPdfViewerItem] = useState();
  const [item, setItem] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [textareaValue, setTextareaValue] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [signHereValue, setSignHereValue] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [checkboxValues, setCheckboxValues] = useState({});
  const [signHereFeildId, setSignHereFeildId] = useState();
  const [reviewerName, setReviewerName] = useState("");
  const [isReview, setIsReview] = useState(true);
  const [isConcent, setIsConsent] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLock, setIsLock] = useState(false);
  const [ind, setInd] = useState(0);
  const [nextInd, setNextInd] = useState(null);
  const [dataItem, setDataItem] = useState("");
  const [deadLine, setDeadline] = useState("");
  const [deadLineDays, setDeadlineDays] = useState(0);
  const [clientReview, setClientReview] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [unconfirmedData, setUnconfirmedData] = useState([]);
  const [photMatchImage, setPhotoMatchImage] = useState("");
  // const [formItem,setFormItem] = useEffect()
  const params = useParams();
  const [user, setUser] = useState({});
  const [message, setMessage] = useState("");
  const [form_item, setForm_item] = useState();
  const [item_form_data, setItem_form_data] = useState();
  const [item_condition, setItem_condition] = useState();
  const [overrideModal, setOverrideModal] = useState(false);
  const [reason, setReason] = useState("");
  const [overrideFormId, setOverrideFormId] = useState("");
  const [templateId, setTemplateId] = useState(0);
  const [onboardingTemplates, setOnboardingTemplates] = useState([]);
  const [fileName, setFilename] = useState("");
  const [mifileName, setMIFilename] = useState("");
  const [l4fileName, setL4Filename] = useState("");
  const [a4fileName, setA4Filename] = useState("");
  const [isOnboarding, setIsOnboarding] = useState(false);

  const [everifyStatus, setEverifyStatus] = useState(false);
  const [tempId, setTempId] = useState(0);
  const [isNewI9Form, setIsNewI9Form] = useState(false);
  const [i9Data, setI9Data] = useState({});

  const currentPath = location.pathname;
  const parts = currentPath.split("/");
  const sectionIndex = useRef();
  // const i9Data = useRef();
  useEffect(() => {
    if (location.state?.tempId !== null) {
      setTempId(location?.state?.tempId);
    }
    if (location.state?.data !== undefined) {
      console.log("inside first ");
      const obj = {
        formfieldid: location.state.data.fields[0].id,
      };
      ApiHelper.post(API.getConvertedDocument, obj)
        .then((res) => {
          console.log("inside second");
          const obj = {
            file_buffer_encrypted_value: res.data.data,
            id: location.state.data.fields[0].id,
          };
          setPdfViewerItem(obj);
          setDataItem(location.state.data);
          console.log("hello here", location.state.data.fields[0]);
          setItem(location.state.data.fields[0]);
          setPdfViewer(true);
          setLoader(false);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
    if (location.pathname === "/review/" + params.id + "/" + params.index) {
      setInd(parseInt(params.index));
      sectionIndex.current = params.index;
      setIsReview(true);
      fetchOnboardingTemplates();
    } else {
      setIsReview(false);
    }
    let isOnboarding = localStorage.getItem("isOnboarding");
    console.log(isOnboarding);
    setIsOnboarding(isOnboarding);
  }, []);

  useEffect(() => {
    if (isReview) {
      const element = document.getElementById("section" + params.index);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [sections]);

  useEffect(() => {
    fetchSections();
    console.log("Executed");
    setUser(JSON.parse(localStorage.getItem("UserData")));
  }, [isReview]);

  async function fetchOnboardingTemplates() {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
      searchkey: "",
    };
    await ApiHelper.post(API.getSectionTemplates, formData)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setOnboardingTemplates(resData?.data?.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }

  // upload files
  const handleFileChange = async (event, id, index, i, j) => {
    // setLoader(true);
    try {
      console.log(event?.target?.files[0]);
      const maxSizeInBytes = 8 * 1024 * 1024; // 8MB
      if (event?.target?.files[0]?.size > maxSizeInBytes) {
        toast("File size too large!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        const file = event.target.files[0];
        setSelectedFile(file);

        const form = new FormData();
        form.append("candidate_document_file", file);
        form.append("intervieweeid", params.id);

        const response = await ApiHelper.mediapost(API.uploadFile, form);
        if (response.data.success === true) {
          let item = [...formData];
          item.map((item1, a) => {
            if (a === index) {
              item1.section_forms.map((item2, b) => {
                if (b === i) {
                  for (let c = 0; c < item2.fields[0].length; c++) {
                    if (c === j) {
                      item2.fields[0][c].documentpath = response.data.filepath;
                    }
                  }
                }
              });
            }
          });
          setFormData(item);
          const obj = {
            formfieldid: id,
            documentpath: response.data.filepath,
            intervieweeid: params.id,
          };
          const data = await ApiHelper.post(API.saveForm, obj).then(
            (resData) => {
              if ((resData.data.success = true)) {
                setLoader(false);
              }
            }
          );
        } else {
          toast(response?.data?.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setLoader(false);
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setLoader(false);
    }
  };

  //   const handleDownloadPDF = async () => {
  //     try {
  //       // Replace 'path/to/your/pdf_file.pdf' with the actual path to your PDF file.
  //       const pdfURL = "/fw4.pdf";
  //       const pdfBlob = await fetch(pdfURL).then((res) => res.blob());

  //       // Create a temporary anchor element to initiate the download.
  //       const a = document.createElement("a");
  //       a.href = URL.createObjectURL(pdfBlob);
  //       a.download = "example.pdf"; // Replace 'example.pdf' with the desired file name.
  //       document.body.appendChild(a);
  //       a.click();
  //       document.body.removeChild(a);
  //     } catch (error) {
  //       console.error("Error downloading PDF:", error);
  //     }
  //   };

  //  download files
  function downloadFile(filepath) {
    const link = document.createElement("a");
    link.href = filepath;
    link.download = "avenu";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    if (sections) {
      createFormData();
    }
  }, [sections]);

  // fetch section and form data
  const fetchSections = async () => {
    let x = 0;
    setLoader(true);
    let isOnboarding = localStorage.getItem("isOnboarding");
    console.log(templateId, location.state?.tempId, isOnboarding);
    const obj = {
      intervieweeid: params?.id,
      template_id: params.tempid !== undefined ? params.tempid : 0,
    };
    const formData = {
      intervieweeid: params?.id,
      template_id:
        isOnboarding === "true"
          ? 0
          : templateId !== 0
          ? templateId
          : location.state?.tempId !== null
          ? location.state?.tempId
          : 0,
    };
    console.log(obj, formData);
    await ApiHelper.post(
      location.pathname === "/review/" + params.id + "/" + params.index
        ? API.getReviewSections
        : API.getCandidateSections,
      location.pathname === "/review/" + params.id + "/" + params.index
        ? formData
        : obj
    )
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setMessage("");
          setIsSubmit(resData?.data?.submit_btn);
          setSections(resData?.data?.data);
          setClientReview(resData?.data?.clientReview);
          setDeadline(resData.data.deadlineDate);
          setProgress(resData?.data?.compltedPercentage);
          console.log(resData?.data?.companyLogo);
          setCompanyLogo(resData?.data?.companyLogo);
          setCompanyAddress(resData?.data?.company_address);
          setCompanyName(resData?.data?.company_name);
          setEverifyStatus(resData?.data?.everify_status);
          setUnconfirmedData(resData?.data?.UnconfirmedData);
          setPhotoMatchImage(resData?.data?.RetrivePhoto);
          const today = new Date();
          let deadLine = new Date(resData.data.deadlineDate);
          const timeDifference = deadLine - today;
          const daysRemaining = Math.ceil(
            timeDifference / (1000 * 60 * 60 * 24)
          );
          console.log(timeDifference, daysRemaining);
          setDeadlineDays(parseInt(daysRemaining));
          if (resData?.data?.clientReview !== null) {
            setIsConsent(true);
            setReviewerName(resData?.data?.clientReview?.name);
          }
          if (resData?.data?.clientReview === null) {
            setIsConsent(false);
            setReviewerName("");
          }
          if (resData.data.options.lock_status === 1) setIsLock(true);
          if (resData.data.options.lock_status === 0) setIsLock(false);

          for (let i = 0; i < resData?.data?.data.length; i++) {
            if (
              resData?.data?.data[i]?.section_forms.length !==
              parseInt(resData?.data?.data[i]?.confirmed_forms_count)
            ) {
              console.log("false");
              x = 1;
            }
          }
          if (x === 0) {
            setLoading(true);
          } else {
            setLoading(false);
          }
        } else {
          setMessage(resData?.data?.message);
        }
        console.log(companyLogo);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  // set value to state formData
  const createFormData = () => {
    let x = JSON.parse(JSON.stringify(sections));
    for (let k = 0; k < x.length; k++) {
      for (let i = 0; i < x[k].section_forms.length; i++) {
        let array = [];
        if (x[k].section_forms[i]?.template_type === "Ohio-it4-combined") {
          getFileName(x[k].section_forms[i]?.id);
        }
        if (x[k].section_forms[i]?.template_type === "MI-W4_Form") {
          getMIFileName(x[k].section_forms[i]?.id);
        }
        if (x[k].section_forms[i]?.template_type === "L4-pdf") {
          getL4FileName(x[k].section_forms[i]?.id);
        }
        if (x[k].section_forms[i]?.template_type === "AR4EC-pdf") {
          getA4FileName(x[k].section_forms[i]?.id);
        }
        for (let j = 0; j < x[k].section_forms[i]?.fields?.length; j++) {
          if (x[k].section_forms[i]?.fields[j]?.field_type_id === 1) {
            array.push({});
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 2) {
            array.push({});
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 3) {
            array.push({});
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 4) {
            array.push({});
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 5) {
            array.push({
              consent:
                x[k].section_forms[i]?.fields?.[j].is_accept_consent === 0
                  ? false
                  : true,
              answer:
                x[k].section_forms[i]?.fields?.[j].interviewee_answer !== null
                  ? x[k].section_forms[i]?.fields?.[j].interviewee_answer
                  : "",
              date:
                x[k].section_forms[i]?.fields?.[j].consent_accepted_date ===
                  "0000-00-00" ||
                x[k].section_forms[i]?.fields?.[j].consent_accepted_date ===
                  null
                  ? new Date()
                  : new Date(
                      x[k].section_forms[i]?.fields?.[j].consent_accepted_date
                    ),
              consentValidate: false,
              answerValidate: false,
            });
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 6) {
            array.push({
              answer:
                x[k].section_forms[i]?.fields?.[j].interviewee_answer !== null
                  ? x[k].section_forms[i]?.fields?.[j].interviewee_answer
                  : "",
              validate: false,
              employee_view: x[k].section_forms[i]?.fields?.[j]?.employee_view,
            });
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 14) {
            array.push({
              answer:
                x[k].section_forms[i]?.fields?.[j].interviewee_answer !== null
                  ? x[k].section_forms[i]?.fields?.[j].interviewee_answer
                  : "",
              isVisible: false,
              validate: false,
            });
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 7) {
            array.push({
              documentpath:
                x[k].section_forms[i]?.fields?.[j].interviewee_document_path,
              validate: false,
            });
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 9) {
            array.push({
              answer:
                x[k].section_forms[i]?.fields?.[j].interviewee_answer !== null
                  ? x[k].section_forms[i]?.fields?.[j].interviewee_answer
                  : "",
              validate: false,
            });
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 11) {
            array.push({});
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 13) {
            array.push({});
          }
          array.isFormConfirmed =
            x[k].section_forms[i].completed_status === 0 ? false : true;
        }
        x[k].section_forms[i]?.fields.splice(
          0,
          x[k].section_forms[i]?.fields.length,
          array
        );
      }
    }
    console.log(x);
    setFormData(x);
  };

  useEffect(() => {
    fetchSections();
  }, [pdfViewer]);

  // save each field value
  const saveForm = async (item, index, i, j) => {
    let obj = {};
    if (item.field_type_id === 5) {
      obj = {
        formfieldid: item.id,
        consent: formData[index]?.section_forms[i]?.fields[0][j]?.consent,
        answer: formData[index]?.section_forms[i]?.fields[0][j]?.answer,
        consentdate: moment(
          formData[index]?.section_forms[i]?.fields[0][j]?.date
        ).format("YYYY-MM-DD"),
      };
    }
    if (item.field_type_id === 9) {
      obj = {
        formfieldid: item.id,
        answer: formData[index]?.section_forms[i]?.fields[0][j]?.answer,
      };
    }
    if (item.field_type_id === 6) {
      obj = {
        formfieldid: item.id,
        answer: formData[index]?.section_forms[i]?.fields[0][j]?.answer,
      };
    }
    if (item.field_type_id === 14) {
      obj = {
        formfieldid: item.id,
        answer: formData[index]?.section_forms[i]?.fields[0][j]?.answer,
      };
    }
    await ApiHelper.post(API.saveForm, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  //submit button and confirm button
  const confirmForm = async (item, data, index, i, e) => {
    // e.preventDefault();
    if (loader === false) {
      setLoader(true);
      let validate = false;
      for (let a = 0; a < data?.fields?.length; a++) {
        if (!isReview) {
          if (data?.fields[a]?.employee_view !== 0) {
            if (data?.fields[a].field_type_id === 7) {
              if (data?.fields[a].is_required === 1) {
                if (
                  formData[index].section_forms[i].fields[0][a].documentpath ===
                    "" ||
                  formData[index].section_forms[i].fields[0][a]
                    ?.documentpath === null
                ) {
                  validate = true;
                  let data = [...formData];
                  data[index].section_forms[i].fields[0][a].validate = true;
                  setFormData(data);
                }
              }
            }
            if (data?.fields[a].field_type_id === 9) {
              if (data?.fields[a].is_required === 1) {
                if (
                  formData[index].section_forms[i].fields[0][a].answer === "" ||
                  formData[index].section_forms[i].fields[0][a]?.answer === null
                ) {
                  validate = true;
                  let data = [...formData];
                  data[index].section_forms[i].fields[0][a].validate = true;
                  setFormData(data);
                }
              }
            }
            if (data?.fields[a].field_type_id === 6) {
              if (data?.fields[a].is_required === 1) {
                if (
                  formData[index].section_forms[i].fields[0][a].answer === "" ||
                  formData[index].section_forms[i].fields[0][a]?.answer === null
                ) {
                  validate = true;
                  let data = [...formData];
                  data[index].section_forms[i].fields[0][a].validate = true;
                  setFormData(data);
                }
              }
            }
            if (data?.fields[a].field_type_id === 14) {
              if (data?.fields[a].is_required === 1) {
                if (
                  formData[index].section_forms[i].fields[0][a].answer === "" ||
                  formData[index].section_forms[i].fields[0][a]?.answer === null
                ) {
                  validate = true;
                  let data = [...formData];
                  data[index].section_forms[i].fields[0][a].validate = true;
                  setFormData(data);
                }
              }
            }
            if (data?.fields[a].field_type_id === 5) {
              if (data?.fields[a].is_required === 1) {
                if (
                  formData[index].section_forms[i].fields[0][a]?.answer ===
                    "" ||
                  formData[index].section_forms[i].fields[0][a]?.answer === null
                ) {
                  validate = true;
                  let data = [...formData];
                  data[index].section_forms[i].fields[0][
                    a
                  ].answerValidate = true;
                  setFormData(data);
                }
                if (
                  formData[index].section_forms[i].fields[0][a].consent ===
                  false
                ) {
                  validate = true;
                  let data = [...formData];
                  data[index].section_forms[i].fields[0][
                    a
                  ].consentValidate = true;
                  setFormData(data);
                }
              }
            }
          }
        }
        if (isReview) {
          if (data?.fields[a].field_type_id === 7) {
            if (data?.fields[a].is_required === 1) {
              if (
                formData[index].section_forms[i].fields[0][a].documentpath ===
                  "" ||
                formData[index].section_forms[i].fields[0][a]?.documentpath ===
                  null
              ) {
                validate = true;
                let data = [...formData];
                data[index].section_forms[i].fields[0][a].validate = true;
                setFormData(data);
              }
            }
          }
          if (data?.fields[a].field_type_id === 9) {
            if (data?.fields[a].is_required === 1) {
              if (
                formData[index].section_forms[i].fields[0][a].answer === "" ||
                formData[index].section_forms[i].fields[0][a]?.answer === null
              ) {
                validate = true;
                let data = [...formData];
                data[index].section_forms[i].fields[0][a].validate = true;
                setFormData(data);
              }
            }
          }
          if (data?.fields[a].field_type_id === 6) {
            if (data?.fields[a].is_required === 1) {
              if (
                formData[index].section_forms[i].fields[0][a].answer === "" ||
                formData[index].section_forms[i].fields[0][a]?.answer === null
              ) {
                validate = true;
                let data = [...formData];
                data[index].section_forms[i].fields[0][a].validate = true;
                setFormData(data);
              }
            }
          }
          if (data?.fields[a].field_type_id === 14) {
            if (data?.fields[a].is_required === 1) {
              if (
                formData[index].section_forms[i].fields[0][a].answer === "" ||
                formData[index].section_forms[i].fields[0][a]?.answer === null
              ) {
                validate = true;
                let data = [...formData];
                data[index].section_forms[i].fields[0][a].validate = true;
                setFormData(data);
              }
            }
          }
          if (data?.fields[a].field_type_id === 5) {
            if (data?.fields[a].is_required === 1) {
              if (
                formData[index].section_forms[i].fields[0][a]?.answer === "" ||
                formData[index].section_forms[i].fields[0][a]?.answer === null
              ) {
                validate = true;
                let data = [...formData];
                data[index].section_forms[i].fields[0][a].answerValidate = true;
                setFormData(data);
              }
              if (
                formData[index].section_forms[i].fields[0][a].consent === false
              ) {
                validate = true;
                let data = [...formData];
                data[index].section_forms[i].fields[0][
                  a
                ].consentValidate = true;
                setFormData(data);
              }
            }
          }
        }
      }

      const ChatbotId = localStorage.getItem("candidateChatbotId");
      let user = JSON.parse(localStorage.getItem("UserData"));
      if (validate) {
        console.log("Fill your form");
        toast("Form Not Completed!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoader(false);
      } else {
        let obj = {
          formid: data.id,
          interviewid: params.id,
          template_id: params.tempid !== undefined ? params.tempid : 0,
        };
        let formData = {
          chatbotid: ChatbotId,
          intervieweeid: params?.id,
          formid: data?.id,
          userId: user?.id,
          template_id:
            templateId !== 0
              ? templateId
              : location.state?.tempId !== null
              ? location.state?.tempId
              : 0,
        };
        await ApiHelper.post(
          isReview ? API.employerConfirm : API.confirmForm,
          isReview ? formData : obj
        )
          .then((resData) => {
            console.log(resData);
            if (resData.data.success === true) {
              fetchSections();
              let filepath = API.legalFormsView + resData?.data?.pdfurl;
              if (!isReview && resData?.data?.pdfurl !== "") {
                const link = document.createElement("a");
                link.href = filepath;
                link.download = "avenu";
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
              toast("Form Completed!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });

              if (item.section_forms?.length === i + 1) {
                setNextInd(index + 1);
              }
              setLoader(false);
            } else {
              toast(resData?.data?.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setLoader(false);
            }
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      }
    }
  };

  const getFileName = async (id) => {
    setLoader(true);
    const obj = {
      intervieweeid: params?.id,
      formid: id,
    };
    await ApiHelper.post(API.downloadForm, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setFilename(resData?.data?.i9Doc);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const getMIFileName = async (id) => {
    setLoader(true);
    const obj = {
      intervieweeid: params?.id,
      formid: id,
    };
    await ApiHelper.post(API.downloadForm, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setMIFilename(resData?.data?.i9Doc);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const getA4FileName = async (id) => {
    setLoader(true);
    const obj = {
      intervieweeid: params?.id,
      formid: id,
    };
    await ApiHelper.post(API.downloadForm, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setA4Filename(resData?.data?.i9Doc);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const getL4FileName = async (id) => {
    setLoader(true);
    const obj = {
      intervieweeid: params?.id,
      formid: id,
    };
    await ApiHelper.post(API.downloadForm, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setL4Filename(resData?.data?.i9Doc);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  // rest form
  const resetForm = async (data) => {
    setLoader(true);
    let isOnboarding = localStorage.getItem("isOnboarding");
    let obj = {
      formid: data.id,
      template_id:
        isOnboarding === "true"
          ? 0
          : templateId !== 0
          ? templateId
          : location.state?.tempId !== null
          ? location.state?.tempId
          : 0,
    };
    await ApiHelper.post(API.resetForm, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          closeModal();
          fetchSections();
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  // reset Section
  const resetSection = async (data) => {
    setLoader(true);
    let obj = {
      sectionid: data.id,
    };
    await ApiHelper.post(API.resetSection, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          closeModal();
          fetchSections();
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  // reset onboarding
  const resetOnboarding = async () => {
    setLoader(true);
    let isOnboarding = localStorage.getItem("isOnboarding");
    let obj = {
      intervieweeid: params.id,
      template_id:
        isOnboarding === "true"
          ? 0
          : location.state?.tempId !== null
          ? location.state?.tempId
          : 0,
      new_template_id:
        templateId !== 0
          ? templateId
          : location.state?.tempId !== null
          ? location.state?.tempId
          : 0,
    };
    await ApiHelper.post(API.resetOnboarding, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          setShowResetModal(false);
          setIsNewI9Form(false);
          // setTemplateId(0);
          fetchSections();
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  // form override so that form will completed
  const overrideForm = async () => {
    setLoader(true);
    let obj = {
      formid: overrideFormId,
      reason: reason,
    };
    await ApiHelper.post(API.overrideForm, obj)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setReason("");
          setOverrideFormId("");
          setOverrideModal(false);
          fetchSections();
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const redirectToEverify = async (id) => {
    setLoader(true);
    let obj = {
      form_id: id,
    };
    await ApiHelper.post(API.redirectToEverify, obj)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setI9Data(resData?.data?.data[0]);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "45%",
      // marginRight: '-50%',
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };

  //reactModal.setAppElement('#yourAppElement');

  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function handleFillablePdf(item, data) {
    setLoader(true);
    const obj = {
      formfieldid: item.id,
    };
    ApiHelper.post(API.getConvertedDocument, obj)
      .then((res) => {
        const obj = {
          file_buffer_encrypted_value: res.data.data,
          id: item.id,
        };
        if (parts[1] == "review") {
          item.field_value = item.interviewee_answer;
          item.file_buffer_encrypted_value =
            item.interviewee_file_buffer_encrypted;
          setPdfViewer(true);
          setPdfViewerItem(obj);
          console.log("data-------------", data);
          setDataItem(data);
          console.log("item--------------", item);
          setItem(item);
        } else {
          setPdfViewer(true);
          setItem(item);
          setPdfViewerItem(obj);
          // navigate('/dashboard/candidates',{ state: { item: item } })
        }
        setLoader(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoader(false);
      });
  }

  const setI9Form = () => {
    setIsNewI9Form(!isNewI9Form);
  };
  // renders html for each elements
  const convert = (item, index, i, j, data) => {
    if (item) {
      if (item.field_type_id === 13) {
        if (parts[1] == "review") {
          return (
            <div>
              <button
                className="confirm-btn rounded p-2"
                onClick={() => handleFillablePdf(item, data)}
              >
                Review Document
              </button>
            </div>
          );
        } else {
          return (
            <div>
              {formData[index]?.section_forms[i]?.fields[0].isFormConfirmed ? (
                <button
                  className="confirm-btn rounded p-2 "
                  style={{ background: "grey" }}
                >
                  Fill document
                </button>
              ) : (
                <button
                  className="confirm-btn rounded p-2 "
                  onClick={() => handleFillablePdf(item)}
                >
                  Fill document
                </button>
              )}
            </div>
          );
        }
      }
      if (item.field_type_id === 9) {
        //checkbox renderer
        return (
          <div style={{ marginBottom: "25px" }}>
            <div
              dangerouslySetInnerHTML={{
                __html: draftToHtml(JSON.parse(item.field_value)),
              }}
            />
            {item.field_options.map((option) => (
              <div className="form-check my-3" key={option.id}>
                <input
                  className="form-check-input"
                  style={{
                    border:
                      formData[index]?.section_forms[i]?.fields[0][j]
                        ?.validate === true
                        ? "1px solid red"
                        : null,
                  }}
                  type="radio"
                  name={`flexRadioDefault_${item.id}`} // Use a unique name for each field
                  id={`flexRadioDefault_${option.form_field_id}_${option.id}`} // Use a unique id for each option
                  checked={
                    formData[index]?.section_forms[i]?.fields[0][j]?.answer ===
                    option.options
                  }
                  value={option.options}
                  onChange={(e) => {
                    if (
                      isReview === false ||
                      (isReview === true &&
                        formData[index]?.section_forms[i]?.fields[0][j]
                          ?.employee_view !== 1)
                    ) {
                      if (
                        isReview === true ||
                        (isReview === false &&
                          !formData[index]?.section_forms[i]?.fields[0]
                            .isFormConfirmed)
                      ) {
                        let data = [...formData];
                        data.map((item1, a) => {
                          if (a === index) {
                            item1.section_forms.map((item2, b) => {
                              if (b === i) {
                                for (
                                  let c = 0;
                                  c < item2.fields[0].length;
                                  c++
                                ) {
                                  if (c === j) {
                                    item2.fields[0][c].answer = e.target.value;
                                  }
                                }
                              }
                            });
                          }
                        });
                        setFormData(data);
                        saveForm(item, index, i, j);
                      }
                    }
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor={`flexRadioDefault_${option.form_field_id}_${option.id}`}
                >
                  {option.options}
                </label>
              </div>
            ))}
          </div>
        );
      } else if (item.field_type_id === 14) {
        return (
          <div style={{ marginBottom: "25px" }}>
            <div
              dangerouslySetInnerHTML={{
                __html: draftToHtml(JSON.parse(item.field_value)),
              }}
            />
            <div class="form-floating ">
              {/* <textarea
                        className="form-control "
                        placeholder="Leave a comment here"
                        id="floatingTextarea"
                        style={{ height: "20px !important" }}
                      ></textarea>*/}
              <div
                class="input-group-append pass-div-width secure-field"
                style={{
                  border:
                    formData[index]?.section_forms[i]?.fields[0][j]
                      ?.validate === true
                      ? "1px solid red"
                      : null,
                  height: "60px",
                }}
              >
                <input
                  type={
                    formData[index]?.section_forms[i]?.fields[0][j]
                      ?.isVisible === true
                      ? "text"
                      : "password"
                  }
                  className="form-control pass-inpt"
                  name="password"
                  placeholder="Enter text here"
                  value={
                    formData[index]?.section_forms[i]?.fields[0][j]?.answer
                  }
                  onChange={(e) => {
                    if (
                      !isReview &&
                      !formData[index]?.section_forms[i]?.fields[0]
                        .isFormConfirmed
                    ) {
                      let data = [...formData];
                      data.map((item1, a) => {
                        if (a === index) {
                          item1.section_forms.map((item2, b) => {
                            if (b === i) {
                              for (let c = 0; c < item2.fields[0].length; c++) {
                                if (c === j) {
                                  item2.fields[0][c].answer = e.target.value;
                                }
                              }
                            }
                          });
                        }
                      });
                      setFormData(data);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !isReview &&
                      !formData[index]?.section_forms[i]?.fields[0]
                        .isFormConfirmed
                    ) {
                      saveForm(item, index, i, j);
                    }
                  }}
                />
                <button
                  type="button"
                  class="btn eye-bttn"
                  data-toggle="password"
                  onClick={() => {
                    let data = [...formData];
                    data.map((item1, a) => {
                      if (a === index) {
                        item1.section_forms.map((item2, b) => {
                          if (b === i) {
                            for (let c = 0; c < item2.fields[0].length; c++) {
                              if (c === j) {
                                item2.fields[0][c].isVisible =
                                  !formData[index]?.section_forms[i]?.fields[0][
                                    j
                                  ]?.isVisible;
                              }
                            }
                          }
                        });
                      }
                    });
                    setFormData(data);
                  }}
                >
                  <img
                    src={
                      formData[index]?.section_forms[i]?.fields[0][j]
                        ?.isVisible === false
                        ? eye
                        : eyeview
                    }
                    alt="test"
                    className="eye-img"
                  />
                  {/* <img src={eyeview} alt="test" className="eye-img" />*/}
                </button>
              </div>
            </div>
          </div>
        );
      } else if (
        item.field_type_id === 3 ||
        item.field_type_id === 4 ||
        item.field_type_id === 5 ||
        item.field_type_id === 7
      ) {
        //image renderer, video render, esignature render and upload button render logics
        if (item.field_type_id === 4) {
          return (
            <div>
              <div
                dangerouslySetInnerHTML={{
                  __html: draftToHtml(JSON.parse(item.field_value)),
                }}
              />
              <div className="img-divs ">
                <video
                  src={API.mediaView + item.file_path}
                  alt="copy"
                  className="video-thumb my-2 "
                  controls
                />
              </div>
            </div>
          );
        }
        if (item.field_type_id === 5) {
          return (
            <div className="chk-text mt-4">
              <div className="form-check wraper">
                <input
                  className="form-check-input"
                  style={{
                    border:
                      formData[index]?.section_forms[i]?.fields[0][j]
                        ?.consentValidate === true
                        ? "1px solid red"
                        : null,
                  }}
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  checked={
                    formData[index]?.section_forms[i]?.fields[0][j]?.consent
                  }
                  onChange={(e) => {
                    if (
                      isReview === false ||
                      (isReview === true &&
                        formData[index]?.section_forms[i]?.fields[0][j]
                          ?.employee_view !== 1)
                    ) {
                      if (
                        isReview === true ||
                        (isReview === false &&
                          !formData[index]?.section_forms[i]?.fields[0]
                            .isFormConfirmed)
                      ) {
                        let data = [...formData];
                        data.map((item1, a) => {
                          if (a === index) {
                            item1.section_forms.map((item2, b) => {
                              if (b === i) {
                                for (
                                  let c = 0;
                                  c < item2.fields[0].length;
                                  c++
                                ) {
                                  if (c === j) {
                                    item2.fields[0][c].consent =
                                      !item2.fields[0][c].consent;
                                  }
                                }
                              }
                            });
                          }
                        });
                        setFormData(data);
                        saveForm(item, index, i, j);
                      }
                    }
                  }}
                  onBlur={() => {
                    if (
                      isReview === false ||
                      (isReview === true &&
                        formData[index]?.section_forms[i]?.fields[0][j]
                          ?.employee_view !== 1)
                    ) {
                      if (
                        isReview === true ||
                        (isReview === false &&
                          !formData[index]?.section_forms[i]?.fields[0]
                            .isFormConfirmed)
                      ) {
                        {
                          saveForm(item, index, i, j);
                        }
                      }
                    }
                  }}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  {item.field_value}
                </label>
              </div>

              <div className="q-btns my-3 d-flex justify-content-between my-1 wraper">
                <div className="row w-100">
                  <div className="col-lg-4 mb-4">
                    <div className="form-floating wraper minH mb-3 over-ride">
                      <input
                        type="text"
                        className="form-control signs"
                        id="signHereInput"
                        style={{
                          border:
                            formData[index]?.section_forms[i]?.fields[0][j]
                              ?.answerValidate === true
                              ? "1px solid red"
                              : null,
                        }}
                        placeholder="name@example.com"
                        value={
                          formData[index]?.section_forms[i]?.fields[0][j]
                            ?.answer
                        }
                        onChange={(e) => {
                          if (
                            isReview === false ||
                            (isReview === true &&
                              formData[index]?.section_forms[i]?.fields[0][j]
                                ?.employee_view !== 1)
                          ) {
                            if (
                              isReview === true ||
                              (isReview === false &&
                                !formData[index]?.section_forms[i]?.fields[0]
                                  .isFormConfirmed)
                            ) {
                              {
                                let data = [...formData];
                                data.map((item1, a) => {
                                  if (a === index) {
                                    item1.section_forms.map((item2, b) => {
                                      if (b === i) {
                                        for (
                                          let c = 0;
                                          c < item2.fields[0].length;
                                          c++
                                        ) {
                                          if (c === j) {
                                            item2.fields[0][c].answer =
                                              e.target.value;
                                          }
                                        }
                                      }
                                    });
                                  }
                                });
                                setFormData(data);
                              }
                            }
                          }
                        }}
                        onBlur={() => {
                          if (
                            isReview === false ||
                            (isReview === true &&
                              formData[index]?.section_forms[i]?.fields[0][j]
                                ?.employee_view !== 1)
                          ) {
                            if (
                              isReview === true ||
                              (isReview === false &&
                                !formData[index]?.section_forms[i]?.fields[0]
                                  .isFormConfirmed)
                            ) {
                              {
                                saveForm(item, index, i, j);
                              }
                            }
                          }
                        }}
                      />
                      <label
                        htmlFor="signHereInput"
                        className=" font-enter-color"
                      >
                        Sign Here
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-floating minH mb-3">
                      <input
                        className="form-control"
                        value={moment(
                          formData[index]?.section_forms[i]?.fields[0][j]?.date
                        ).format("MMMM D, YYYY")}
                      />
                      <label htmlFor="dateInput" className=" font-enter-color">
                        Date
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
        if (item.field_type_id === 7) {
          return (
            <div className="two-buttn wraper upPsty">
              <div
                dangerouslySetInnerHTML={{
                  __html: draftToHtml(JSON.parse(item.field_value)),
                }}
              />
              {/* <img style={{ width: '100px', display: 'block' }} src={API.mediaView + item.file_path} alt='form-dep' /> */}

              <div className="d-flex py-2 wraper">
                <div className="inpWid wraper">
                  <div
                    className="inptFiles_up aligDivs_rev"
                    style={{ position: "relative" }}
                  >
                    <div>
                      {!isReview &&
                      !formData[index]?.section_forms[i]?.fields[0]
                        .isFormConfirmed ? (
                        <input
                          type="file"
                          style={{
                            left: "0",
                            top: "0px",
                            margin: "0",
                            width: "92px",
                            position: "absolute",
                          }}
                          onChange={(event) => {
                            handleFileChange(event, item.id, index, i, j);
                          }}
                        />
                      ) : null}
                      {/* <button style={{ border: formData[index]?.section_forms[i]?.fields[0][j]?.validate === true ? '1px solid red' : null }}>Upload</button> */}
                      {!isReview && (
                        <button
                          type="button"
                          className="upBtn"
                          style={{
                            margin: "0px",
                            position: "relative",
                            float: "left",
                            border:
                              formData[index]?.section_forms[i]?.fields[0][j]
                                ?.validate === true &&
                              formData[index]?.section_forms[i]?.fields[0][j]
                                ?.documentpath === null
                                ? "1px solid red"
                                : null,
                          }}
                        >
                          Upload
                        </button>
                      )}
                      {isReview &&
                        item?.interviewee_document_path !== "" &&
                        item?.interviewee_document_path !== null && (
                          <button
                            type="button"
                            className="upBtn aligBtn-view"
                            onClick={() => {
                              downloadFile(
                                API.mediaView + item?.interviewee_document_path
                              );
                            }}
                            style={{ pointerEvents: "all" }}
                          >
                            View
                          </button>
                        )}
                      <p
                        style={{
                          zIndex: "0",
                          margin: "8px 0px 0px 10px",
                          float: "left",
                        }}
                      >
                        {formData[index]?.section_forms[i]?.fields[0][
                          j
                        ]?.documentpath
                          ?.split("/")
                          ?.pop()}
                      </p>
                    </div>
                  </div>
                </div>
                {/* {!isReview && !formData[index]?.section_forms[i]?.fields[0].isFormConfirmed && <div className='btnWid text-center'><img src={closex} alt="close" className="close-icon" /></div>} */}
              </div>
            </div>
          );
        }
        return (
          <div className="wraper">
            <div
              dangerouslySetInnerHTML={{
                __html: draftToHtml(JSON.parse(item.field_value)),
              }}
            />
            <div
              className={
                item.file_alignment === "left"
                  ? "img-divs divs-left-algment"
                  : item.file_alignment === "center"
                  ? "img-divs divs-center-algment"
                  : item.file_alignment === "right"
                  ? "img-divs divs-right-algment"
                  : null
              }
            >
              <img
                className={
                  item.file_alignment === "left" && item.file_size === "small"
                    ? "video-thumb my-2 imgs-left-algment image-sizes-small"
                    : item.file_alignment === "left" &&
                      item.file_size === "medium"
                    ? "video-thumb my-2 imgs-left-algment image-sizes-medm"
                    : item.file_alignment === "left" &&
                      item.file_size === "large"
                    ? "video-thumb my-2 imgs-left-algment image-sizes-large"
                    : item.file_alignment === "center" &&
                      item.file_size === "small"
                    ? "video-thumb my-2 imgs-center-algment image-sizes-small"
                    : item.file_alignment === "center" &&
                      item.file_size === "medium"
                    ? "video-thumb my-2 imgs-center-algment image-sizes-medm"
                    : item.file_alignment === "center" &&
                      item.file_size === "large"
                    ? "video-thumb my-2 imgs-center-algment image-sizes-large"
                    : item.file_alignment === "right" &&
                      item.file_size === "small"
                    ? "video-thumb my-2 imgs-right-algment image-sizes-small"
                    : item.file_alignment === "right" &&
                      item.file_size === "medium"
                    ? "video-thumb my-2 imgs-right-algment image-sizes-medm"
                    : item.file_alignment === "right" &&
                      item.file_size === "large"
                    ? "video-thumb my-2 imgs-right-algment image-sizes-large"
                    : null
                }
                src={API.mediaView + item.file_path}
                alt="form-dep"
              />
            </div>
          </div>
        );
      } else if (item.field_type_id === 11) {
        return (
          <div className="row w-100">
            <div className="col-lg-4">
              <p>
                <div
                  dangerouslySetInnerHTML={{
                    __html: draftToHtml(JSON.parse(item.field_value)),
                  }}
                />
              </p>
              <div className="btnAlg_same">
                <button
                  className="btn btn-primary my-2 review-btn"
                  onClick={() => {
                    downloadFile(API.mediaView + item?.file_path);
                  }}
                >
                  Review Document
                </button>
              </div>
            </div>
          </div>
        );
      }
      <div className="row w-100">
        <div className="col-lg-4 mb-4">
          <div className="document-view">
            <h2>please fill the form</h2>
          </div>
        </div>
      </div>;
      //     )
      // }

      if (item.field_type_id === 1) {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: draftToHtml(JSON.parse(item.field_value)),
            }}
          />
        );
      }
      if (item.field_type_id === 2) {
        console.log(
          "Check",
          JSON.parse(item.field_value),
          draftToHtml(JSON.parse(item.field_value))
        );
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: draftToHtml(JSON.parse(item.field_value)),
            }}
          />
        );
      }
      if (item.field_type_id === 6) {
        return (
          <div style={{ marginBottom: "25px" }}>
            <div
              dangerouslySetInnerHTML={{
                __html: draftToHtml(JSON.parse(item.field_value)),
              }}
            />
            <div class="form-floating">
              <textarea
                style={{
                  border:
                    formData[index]?.section_forms[i]?.fields[0][j]
                      ?.validate === true
                      ? "1px solid red"
                      : null,
                }}
                className="form-control "
                placeholder="Leave a comment here"
                id="floatingTextarea"
                value={formData[index]?.section_forms[i]?.fields[0][j]?.answer}
                onChange={(e) => {
                  if (
                    isReview === false ||
                    (isReview === true &&
                      formData[index]?.section_forms[i]?.fields[0][j]
                        ?.employee_view !== 1)
                  ) {
                    if (
                      isReview === true ||
                      (isReview === false &&
                        !formData[index]?.section_forms[i]?.fields[0]
                          .isFormConfirmed)
                    ) {
                      let data = [...formData];
                      data.map((item1, a) => {
                        if (a === index) {
                          item1.section_forms.map((item2, b) => {
                            if (b === i) {
                              for (let c = 0; c < item2.fields[0].length; c++) {
                                if (c === j) {
                                  item2.fields[0][c].answer = e.target.value;
                                }
                              }
                            }
                          });
                        }
                      });
                      setFormData(data);
                    }
                  }
                }}
                onBlur={() => {
                  if (
                    isReview === false ||
                    (isReview === true &&
                      formData[index]?.section_forms[i]?.fields[0][j]
                        ?.employee_view !== 1)
                  ) {
                    if (
                      isReview === true ||
                      (isReview === false &&
                        !formData[index]?.section_forms[i]?.fields[0]
                          .isFormConfirmed)
                    ) {
                      saveForm(item, index, i, j);
                    }
                  }
                }}
              />
              <label htmlFor="floatingTextarea" className="font-enter-color">
                Enter text here
              </label>
            </div>
          </div>
        );
      }
    }
  };

  const isLocked = (index, i, data) => {
    if (!isReview) {
      if (isLock) {
        if (index === 0) {
          if (i == 0) {
            return `#innerCollapse${data.id}`;
          } else {
            if (sections[index]?.section_forms[i - 1]?.completed_status === 1) {
              return `#innerCollapse${data.id}`;
            } else {
              return "";
            }
          }
        } else {
          if (i == 0) {
            if (
              sections[index - 1]?.section_forms[
                sections[index - 1]?.section_forms.length - 1
              ]?.completed_status === 1
            ) {
              return `#innerCollapse${data.id}`;
            } else {
              return "";
            }
          } else {
            if (sections[index]?.section_forms[i - 1]?.completed_status === 1) {
              return `#innerCollapse${data.id}`;
            } else {
              return "";
            }
          }
        }
      } else {
        return `#innerCollapse${data.id}`;
      }
    } else {
      return `#innerCollapse${data.id}`;
    }
  };

  // toast for lock flow
  const showToast = (index, i, data) => {
    if (!isReview) {
      if (isLock) {
        if (index === 0) {
          if (i == 0) {
            return `#innerCollapse${data.id}`;
          } else {
            if (sections[index]?.section_forms[i - 1]?.completed_status === 1) {
              return `#innerCollapse${data.id}`;
            } else {
              toast("Fill the above forms!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
          }
        } else {
          if (i == 0) {
            if (
              sections[index - 1]?.section_forms[
                sections[index - 1]?.section_forms.length - 1
              ]?.completed_status === 1
            ) {
              return `#innerCollapse${data.id}`;
            } else {
              toast("Fill the above forms!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
          } else {
            if (sections[index]?.section_forms[i - 1]?.completed_status === 1) {
              return `#innerCollapse${data.id}`;
            } else {
              toast("Fill the above forms!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
          }
        }
      } else {
        return `#innerCollapse${data.id}`;
      }
    } else {
      return `#innerCollapse${data.id}`;
    }
  };

  // review candidate
  const reviewCandidate = async () => {
    let validate = false;
    for (let i = 0; i < sections.length; i++) {
      for (let j = 0; j < sections[i]?.section_forms.length; j++) {
        for (let a = 0; a < sections[i]?.section_forms[j].fields.length; a++) {
          if (sections[i]?.section_forms[j]?.employer_override !== 1) {
            if (
              sections[i]?.section_forms[j]?.template_type === "i-9form" ||
              sections[i]?.section_forms[j]?.template_type === "w4-form"
            ) {
              if (
                formData[i]?.section_forms[j].completed_status === 0 ||
                formData[i]?.section_forms[j].employer_status === 0
              ) {
                validate = true;
              }
            } else if (
              sections[i]?.section_forms[j]?.fields[a].field_type_id === 13
            ) {
              if (
                formData[i]?.section_forms[j].completed_status === 0 ||
                formData[i]?.section_forms[j].employer_status === 0
              ) {
                validate = true;
                let data = [...formData];
                data[i].section_forms[j].fields[0][a].validate = true;
                setFormData(data);
              }
            } else {
              if (formData[i]?.section_forms[j].completed_status === 0) {
                validate = true;
              }
            }
          }
        }
      }
    }

    if (validate === true) {
      toast("Please review all the forms and documents", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      if (isConcent === false || reviewerName === "") {
        setIsError(true);
      } else {
        setLoader(true);
        setIsError(false);
        let user = JSON.parse(localStorage.getItem("UserData"));
        let isOnboarding = localStorage.getItem("isOnboarding");
        const obj = {
          userid: user.id,
          intervieweeid: params.id,
          name: reviewerName,
        };
        const formData = {
          userid: user.id,
          intervieweeid: params.id,
          name: reviewerName,
          template_id:
            templateId !== 0
              ? templateId
              : location.state?.tempId !== null
              ? location.state?.tempId
              : 0,
        };

        await ApiHelper.post(
          API.reviewCandidate,
          isOnboarding === "true" ? obj : formData
        )
          .then((resData) => {
            if (resData.data.success === true) {
              toast("Form Reviewed", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              let isOnboarding = localStorage.getItem("isOnboarding");
              isOnboarding === "true" || isOnboarding === null
                ? navigate("/dashboard/candidates")
                : navigate("/dashboard/onboarding/my-team");
              setLoader(false);
            }
          })
          .catch((err) => {
            setLoader(false);
          });
      }
    }
  };

  // scroll to review and confirm
  const handleScroll = () => {
    const element = document.getElementById("review");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // scroll to sections
  const scrollToSection = (index) => {
    const element = document.getElementById("section" + index);
    if (element) {
      console.log(element);
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const stickyDiv = useRef();
  useEffect(() => {
    console.log("scroll");
    const main = document.getElementById("main");
    main.addEventListener("scroll", () => {
      const container = document.getElementById("container");
      console.log(main.scrollTop);
      if (main.scrollTop > 130) {
        container.classList.add("top-id-fixes");
      } else {
        container.classList.remove("top-id-fixes");
      }
    });
  }, []);

  return (
    <>
      {message === "" ? (
        <div className="container-fluid" id="main">
          <div className="fixHeader candPrv">
            <div className="row">
              <div className="col-lg-2 col-md-3 sideCont">
                <div className="hd-left">
                  {isReview && (
                    <img
                      src={Menu}
                      alt="test"
                      className="preview-bck-icon"
                      onClick={() => {
                        pdfViewer === true
                          ? setPdfViewer(false)
                          : isNewI9Form === true
                          ? setIsNewI9Form(false)
                          : navigate(-1);
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="w-100 logo-sec">
                <div className="logoCent logo-sec">
                  <img
                    src={companyLogo !== null && API.avenuView + companyLogo}
                    alt="logo"
                    className="logo-inner mb-0 me-2"
                  />
                </div>
                <div className="logoSide logo-sec">
                  <img
                    src={LogoPw}
                    alt="copy"
                    className="logo-inner mb-0 me-2"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row px-4 topSpce_view">
            {isNewI9Form === true ? (
              <>
                <div className="col-lg-2 col-md-3 sideCont">
                  <div className="action-itms full-drp">
                    <ul className="status-ind mb-0">
                      <li className="mb-0">
                        <a className="textSty">
                          <img
                            src={caseLogo}
                            alt="copy"
                            className="logo-inner mb-0 me-2"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-10 col-md-9 rightCont">
                  <div className="px-5 contents-sub w-100  collapse padd-main show action-itms">
                    <I9form
                      review={isReview}
                      data={i9Data}
                      companyName={companyName}
                      companyAddress={companyAddress}
                      verifyStatus={everifyStatus}
                      fetchSections={fetchSections}
                      unconfirmedData={unconfirmedData}
                      photMatchImage={photMatchImage}
                      resetForm={resetForm}
                      isNewI9Form={isNewI9Form}
                      redirectToEverify={redirectToEverify}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-lg-2 col-md-3 sideCont">
                  {message === "" && (
                    <div className="sidebarFixs">
                      <div className="sideScroll">
                        <div
                          className="action-itms full-drp  inner-scrll create-comp-scroll scrlHe-tab scroll scroll1"
                          style={{ alignitems: "flex-start" }}
                        >
                          <ul
                            className="status-ind viewList"
                            style={{ margin: "0" }}
                          >
                            {sections.map((item, index) => {
                              return (
                                item?.section_forms.length !== 0 && (
                                  <li
                                    onClick={() => {
                                      scrollToSection(index);
                                      sectionIndex.current = index;
                                      setInd(index);
                                    }}
                                  >
                                    <a className="review-pre-cand-link">
                                      <img
                                        src={
                                          item?.confirmed_forms_count ===
                                          item?.section_forms?.length
                                            ? success
                                            : circle
                                        }
                                        alt="copy"
                                        className="create-icon mb-0 me-2"
                                      />
                                      {item.section_name}
                                    </a>
                                  </li>
                                )
                              );
                            })}
                            {/* 
                                    <li>
                                        <a href='#' className=''><img src={Alert} alt="copy" className="create-icon mb-0 me-2" />Federal Tax</a>
                                    </li>
                                    <li>
                                        <a href='#' className=''><img src={Alert} alt="copy" className="create-icon mb-0 me-2" />State Tax</a> */}
                            {/* </li> */}
                            {/* <li style={{ margin: '20px 0 0' }}>
                                        <a href='#' className='textSty'><img src={uparrow} alt="copy" className="create-icon mb-0 me-2" />Back to Top</a>
                                    </li> */}
                          </ul>
                        </div>
                        {/* <div className='action-itms full-drp'>
                                <ul className='status-ind mb-0' >
                                    <li className='mb-0'>
                                        <a href='#' className=''><img src={Info} alt="copy" className="create-icon mb-0 me-2" />Offer Letter</a>
                                    </li>
                                </ul>
                            </div> */}

                        {isReview && (
                          <div className="action-itms full-drp">
                            <ul className="status-ind mb-0">
                              <li
                                className="mb-0"
                                onClick={() => {
                                  console.log("Clicked");
                                  setShowResetModal(true);
                                }}
                              >
                                <a
                                  className="textSty"
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={arrow}
                                    alt="copy"
                                    className="create-icon mb-0 me-2"
                                  />
                                  {isOnboarding === "true"
                                    ? "Restart Onboarding"
                                    : "Restart"}
                                </a>
                              </li>
                            </ul>
                          </div>
                        )}

                        <div className="action-itms full-drp statBox text-center">
                          <p className="titles">
                            {deadLineDays < 0 ? (
                              "Expired"
                            ) : (
                              <>
                                {deadLineDays}{" "}
                                {deadLineDays > 1
                                  ? " days remaining"
                                  : " day remaining"}
                              </>
                            )}
                          </p>
                          <p className="descp">
                            {moment(deadLine).format("DD MMM YYYY")}
                          </p>
                        </div>

                        {isReview && (
                          <div
                            className="action-itms full-drp"
                            onClick={handleScroll}
                          >
                            <ul className="status-ind mb-0">
                              <li className="mb-0">
                                <a className="textSty">
                                  <img
                                    src={Info}
                                    alt="copy"
                                    className="create-icon mb-0 me-2"
                                  />
                                  Review & Confirm
                                </a>
                              </li>
                            </ul>
                          </div>
                        )}

                        {/* <div className='action-itms full-drp'>
                                <ul className='status-ind mb-0' >
                                    <li className='mb-0'>
                                        <a href='#' className=''><img src={Info} alt="copy" className="create-icon mb-0 me-2" />Need Help ?</a>
                                    </li>
                                </ul>
                            </div> */}

                        {/* <div className='action-itms full-drp'>
                                <ul className='status-ind mb-0' >
                                    <li className='mb-0'>
                                        <a href='#' className=''><img src={Info} alt="copy" className="create-icon mb-0 me-2" />Go Back</a>
                                    </li>
                                </ul>
                            </div> */}

                        {/* <div className='action-itms full-drp'>
                                <ul className='status-ind mb-0' >
                                    <li className='mb-0'>
                                        <a href='#' className=''><img src={Info} alt="copy" className="create-icon mb-0 me-2" />Need Help ?</a>
                                    </li>
                                </ul>
                            </div> */}

                        <div className="progress custom me-3">
                          <div
                            className="progress-bar2"
                            style={{ width: `${progress}%` }}
                            role="progressbar"
                            aria-valuenow="0"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </div>{" "}
                    </div>
                  )}
                </div>
                {pdfViewer ? (
                  <div className="col-lg-10 col-md-9 rightCont">
                    {/* <FillablePdf item={pdfViewerItem} setPdfViewer={setPdfViewer} /> */}
                    <FillablePdf
                      intervieweeid={params.id}
                      data={dataItem}
                      setModalData={setModalData}
                      setIsOpen={setIsOpen}
                      form={item}
                      item={pdfViewerItem}
                      setPdfViewer={setPdfViewer}
                      currentPath={parts[1]}
                    />
                  </div>
                ) : (
                  <div id="container" className="col-lg-10 col-md-9 rightCont">
                    {sections.map((item, index) => {
                      return (
                        item?.section_forms.length !== 0 && (
                          <div
                            className="action-itms full-drp flex-column collap-main "
                            id={"section" + index}
                          >
                            <div
                              className="row collap-head"
                              style={{ width: "100%" }}
                              data-bs-toggle="collapse"
                              href={`#outerCollapse${item.id}`}
                            >
                              <div className="col-lg-6">
                                <div className="hd-can-review create-form-wrp newPad alig_cent">
                                  {isReview ? (
                                    <h4 className="mainTits">
                                      <img
                                        src={
                                          item?.confirmed_forms_count ===
                                          item?.section_forms?.length
                                            ? success
                                            : circle
                                        }
                                        alt="copy"
                                        className="create-icon mb-0 me-2"
                                      />
                                      {item.section_name}
                                      {/* <button className='confirm-btn rounded p-2 ' onClick={() => {
                                                            setModalData(
                                                                {
                                                                    item: 'section',
                                                                    itemName: item?.section_name,
                                                                    data: item
                                                                }
                                                            )
                                                            setIsOpen(true)
                                                        }}>Reset Section</button> */}{" "}
                                    </h4>
                                  ) : (
                                    <h4>
                                      <img
                                        src={
                                          item?.confirmed_forms_count ===
                                          item?.section_forms?.length
                                            ? success
                                            : circle
                                        }
                                        alt="copy"
                                        className="create-icon mb-0 me-2"
                                      />
                                      {item.section_name}
                                    </h4>
                                  )}

                                  <p className="mb-0 pt-2 sub-head-color padd-main">
                                    {item?.subtitle}
                                  </p>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="width-flex w-100">
                                  <div className="alignHead_review right-side-align">
                                    <div className="task-count">
                                      <div className="progress custom me-3">
                                        <div
                                          className="progress-bar2"
                                          style={{
                                            width: `${
                                              (item?.confirmed_forms_count /
                                                item?.section_forms?.length) *
                                              100
                                            }%`,
                                          }}
                                          role="progressbar"
                                          aria-valuenow="0"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                      <div className="task-itms">
                                        <span>
                                          {item?.confirmed_forms_count} of{" "}
                                          {item?.section_forms?.length} tasks
                                        </span>
                                      </div>
                                      <button className="select-btn">
                                        <img
                                          src={dropdown}
                                          alt="test"
                                          className="drp top-drp"
                                        />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className={
                                ind === index || nextInd === index
                                  ? "contents-sub w-100 mt-0 padd-main collapse show"
                                  : " contents-sub w-100 mt-3 padd-main collapse"
                              }
                              id={`outerCollapse${item.id}`}
                            >
                              {item.section_forms.map((data, i) => {
                                return (
                                  <div className="action-itms  padd-review-page  full-drp w-100 flex-column exit">
                                    <div
                                      className={
                                        (ind === index || nextInd === index) &&
                                        i === 0
                                          ? "action-itms padd-review-inner full-drp w-100 collap-head  border-0 mb-0"
                                          : "action-itms padd-review-inner full-drp w-100 collap-head  border-0 mb-0 collapsed"
                                      }
                                      data-bs-toggle="collapse"
                                      data-bs-target={isLocked(index, i, data)}
                                      onClick={() => {
                                        showToast(index, i, data);
                                      }}
                                    >
                                      {isReview && (
                                        <div className="dropdown">
                                          <button className="dropbtn">
                                            <img
                                              src={dots}
                                              alt="document"
                                              className="three-dots-img"
                                            />{" "}
                                          </button>
                                          <div
                                            className="dropdown-content"
                                            onClick={() => {
                                              setOverrideModal(true);
                                              setOverrideFormId(data.id);
                                            }}
                                          >
                                            <a className="button" href="#">
                                              Mark as complete
                                            </a>
                                          </div>
                                        </div>
                                      )}
                                      <div className="alignHead_review">
                                        <div
                                          className="hd-can-review create-form-wrp newPad"
                                          style={{ display: "flex" }}
                                        >
                                          {isReview ? (
                                            <h4>
                                              <img
                                                src={
                                                  data?.completed_status === 0
                                                    ? circle
                                                    : success
                                                }
                                                alt="copy"
                                                className="create-icon mb-0 me-2"
                                              />
                                              {data?.title}
                                            </h4>
                                          ) : (
                                            <h4>
                                              <img
                                                src={
                                                  data?.completed_status === 0
                                                    ? circle
                                                    : success
                                                }
                                                alt="copy"
                                                className="create-icon mb-0 me-2"
                                              />
                                              {data?.title}
                                            </h4>
                                          )}

                                          <div className="over-divz">
                                            {data?.employer_override === 1 && (
                                              <>
                                                <button
                                                  type="button"
                                                  class="btn btn-success Overrided-bttn"
                                                >
                                                  Overrided
                                                </button>
                                                <p className="i9-text">
                                                  {data?.override_reason}
                                                </p>
                                              </>
                                            )}
                                          </div>
                                        </div>

                                        <div className="task-count rev-marg-lft">
                                          {isReview &&
                                            data?.e_verify_casId === null && (
                                              <button
                                                className="resetform-btn rounded p-2 "
                                                onClick={() => {
                                                  setModalData({
                                                    item: "form",
                                                    itemName: data?.title,
                                                    data: data,
                                                  });
                                                  setIsOpen(true);
                                                }}
                                              >
                                                Restart Form
                                              </button>
                                            )}
                                          <button className="select-btn">
                                            <img
                                              src={dropdown}
                                              alt="test"
                                              className="drp top-drp"
                                            />
                                          </button>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="mobile-over-divz">
                                      {data?.employer_override === 1 && (
                                        <>
                                          <button
                                            type="button"
                                            class="btn btn-success Overrided-bttn"
                                          >
                                            Overrided
                                          </button>
                                          <p className="i9-text">
                                            {data?.override_reason}
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    <p className="mb-0 pt-2 sub-head-color  padd-main">
                                      {data?.subtitle == "converted document" ||
                                      data?.subtitle == "adminI9Pdf"
                                        ? ""
                                        : data?.subtitle}
                                    </p>

                                    <div
                                      className={
                                        (ind === index || nextInd === index) &&
                                        i === 0
                                          ? "contents-sub w-100  collapse padd-main show"
                                          : "contents-sub w-100  collapse padd-main"
                                      }
                                      id={`innerCollapse${data.id}`}
                                    >
                                      {data?.template_type === "w4-form" ? (
                                        <W4form
                                          review={isReview}
                                          data={data}
                                          fetchSections={fetchSections}
                                        />
                                      ) : data?.template_type === "i-9form" &&
                                        data?.legal_form_version !== null ? (
                                        <I9form
                                          review={isReview}
                                          data={data}
                                          companyName={companyName}
                                          companyAddress={companyAddress}
                                          verifyStatus={everifyStatus}
                                          fetchSections={fetchSections}
                                          unconfirmedData={unconfirmedData}
                                          photMatchImage={photMatchImage}
                                          resetForm={resetForm}
                                          isNewI9Form={isNewI9Form}
                                          redirectToEverify={redirectToEverify}
                                        />
                                      ) : data?.template_type === "i-9form" &&
                                        data?.legal_form_version === null ? (
                                        <OldI9form
                                          review={isReview}
                                          data={data}
                                          companyName={companyName}
                                          companyAddress={companyAddress}
                                          verifyStatus={everifyStatus}
                                          fetchSections={fetchSections}
                                          unconfirmedData={unconfirmedData}
                                          photMatchImage={photMatchImage}
                                          resetForm={resetForm}
                                          isNewI9Form={isNewI9Form}
                                          redirectToEverify={redirectToEverify}
                                          setI9Form={setI9Form}
                                        />
                                      ) : data?.template_type ===
                                        "W4Sc-form" ? (
                                        <W4South
                                          review={isReview}
                                          data={data}
                                          fetchSections={fetchSections}
                                        />
                                      ) : (
                                        data.fields?.map((value, j) => (
                                          <div className="me-3 mb-4 rev-padd-tap">
                                            {isReview
                                              ? convert(
                                                  value,
                                                  index,
                                                  i,
                                                  j,
                                                  data
                                                )
                                              : value.employee_view === 1 &&
                                                convert(
                                                  value,
                                                  index,
                                                  i,
                                                  j,
                                                  data
                                                )}
                                          </div>
                                        ))
                                      )}

                                      {data.completed_status === 0 &&
                                        !isReview &&
                                        data.fields[0]?.field_type_id !== 13 &&
                                        data.template_type !== "w4-form" &&
                                        data.template_type !== "i-9form" &&
                                        data.template_type !== "W4Sc-form" && (
                                          <div className="col-lg-12  align-items-center justify-content-end">
                                            <div className="form-floating mb-3 justify-content-end wraper">
                                              <button
                                                className="submits-btn rounded p-2 mt-2"
                                                onClick={(e) => {
                                                  loader === false &&
                                                    confirmForm(
                                                      item,
                                                      data,
                                                      index,
                                                      i,
                                                      e
                                                    );
                                                }}
                                              >
                                                {item.section_forms?.length ===
                                                i + 1
                                                  ? "Submit Form"
                                                  : "Next Form"}{" "}
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                      {data.employer_status === 0 &&
                                        isReview &&
                                        data.completed_status === 1 &&
                                        (data?.template_type === "MI-W4_Form" ||
                                          data?.template_type === "L4-pdf") && (
                                          <div className="col-lg-12  align-items-center justify-content-end">
                                            <div className="form-floating mb-3 justify-content-end wraper">
                                              <button
                                                className="submits-btn rounded p-2"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  confirmForm(
                                                    item,
                                                    data,
                                                    index,
                                                    i,
                                                    e
                                                  );
                                                }}
                                              >
                                                {" "}
                                                Confirm Form{" "}
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                      {isReview &&
                                        data?.template_type ===
                                          "Ohio-it4-combined" &&
                                        fileName !== "" && (
                                          <div className="col-lg-12  align-items-center justify-content-end">
                                            <div className="form-floating mb-3 justify-content-end wraper">
                                              <button
                                                className="submits-btn rounded p-2 sub-bttn-right-sides"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  let filepath =
                                                    API.legalFormsView +
                                                    fileName;
                                                  if (fileName !== "") {
                                                    const link =
                                                      document.createElement(
                                                        "a"
                                                      );
                                                    link.href = filepath;
                                                    link.download = "avenu";
                                                    link.target = "_blank";
                                                    document.body.appendChild(
                                                      link
                                                    );
                                                    link.click();
                                                    document.body.removeChild(
                                                      link
                                                    );
                                                  }
                                                }}
                                              >
                                                Download{" "}
                                              </button>

                                              {/* <button className='submits-btn rounded p-2 sub-bttn-right-sides' 
                                                                    onClick={(e) => { submitForm(e, 'Updated') }}> Update Form </button> */}
                                            </div>
                                          </div>
                                        )}
                                      {isReview &&
                                        data?.template_type === "MI-W4_Form" &&
                                        mifileName !== "" && (
                                          <div className="col-lg-12  align-items-center justify-content-end">
                                            <div className="form-floating mb-3 justify-content-end wraper">
                                              <button
                                                className="submits-btn rounded p-2 sub-bttn-right-sides"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  let filepath =
                                                    API.legalFormsView +
                                                    mifileName;
                                                  if (mifileName !== "") {
                                                    const link =
                                                      document.createElement(
                                                        "a"
                                                      );
                                                    link.href = filepath;
                                                    link.download = "avenu";
                                                    link.target = "_blank";
                                                    document.body.appendChild(
                                                      link
                                                    );
                                                    link.click();
                                                    document.body.removeChild(
                                                      link
                                                    );
                                                  }
                                                }}
                                              >
                                                Download{" "}
                                              </button>

                                              {/* <button className='submits-btn rounded p-2 sub-bttn-right-sides' 
                                                                    onClick={(e) => { submitForm(e, 'Updated') }}> Update Form </button> */}
                                            </div>
                                          </div>
                                        )}
                                      {isReview &&
                                        data?.template_type === "AR4EC-pdf" &&
                                        a4fileName !== "" && (
                                          <div className="col-lg-12  align-items-center justify-content-end">
                                            <div className="form-floating mb-3 justify-content-end wraper">
                                              <button
                                                className="submits-btn rounded p-2 sub-bttn-right-sides"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  let filepath =
                                                    API.legalFormsView +
                                                    a4fileName;
                                                  if (a4fileName !== "") {
                                                    const link =
                                                      document.createElement(
                                                        "a"
                                                      );
                                                    link.href = filepath;
                                                    link.download = "avenu";
                                                    link.target = "_blank";
                                                    document.body.appendChild(
                                                      link
                                                    );
                                                    link.click();
                                                    document.body.removeChild(
                                                      link
                                                    );
                                                  }
                                                }}
                                              >
                                                Download{" "}
                                              </button>

                                              {/* <button className='submits-btn rounded p-2 sub-bttn-right-sides' 
                                                                    onClick={(e) => { submitForm(e, 'Updated') }}> Update Form </button> */}
                                            </div>
                                          </div>
                                        )}
                                      {isReview &&
                                        data?.template_type === "L4-pdf" &&
                                        l4fileName !== "" && (
                                          <div className="col-lg-12  align-items-center justify-content-end">
                                            <div className="form-floating mb-3 justify-content-end wraper">
                                              <button
                                                className="submits-btn rounded p-2 sub-bttn-right-sides"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  let filepath =
                                                    API.legalFormsView +
                                                    l4fileName;
                                                  if (l4fileName !== "") {
                                                    const link =
                                                      document.createElement(
                                                        "a"
                                                      );
                                                    link.href = filepath;
                                                    link.download = "avenu";
                                                    link.target = "_blank";
                                                    document.body.appendChild(
                                                      link
                                                    );
                                                    link.click();
                                                    document.body.removeChild(
                                                      link
                                                    );
                                                  }
                                                }}
                                              >
                                                Download{" "}
                                              </button>

                                              {/* <button className='submits-btn rounded p-2 sub-bttn-right-sides' 
                                                                    onClick={(e) => { submitForm(e, 'Updated') }}> Update Form </button> */}
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )
                      );
                    })}
                    {console.log(sections)}
                    {!isReview && sections.length !== 0 && isSubmit && (
                      <>
                        {" "}
                        {loading ? (
                          <div className="col-lg-12 align-items-center justify-content-end">
                            <div className="form-floating mb-3 d-flex justify-content-end">
                              <button
                                className="next-btn rounded p-2"
                                onClick={(e) => {
                                  navigate("/thank-you/" + params.id);
                                }}
                              >
                                Submit
                              </button>
                            </div>{" "}
                          </div>
                        ) : null}
                        {!loading ? (
                          <div className="col-lg-12 align-items-center justify-content-end">
                            <div className="form-floating mb-3 d-flex justify-content-end">
                              <button
                                className="next-btn rounded p-2"
                                style={{ background: "grey" }}
                              >
                                Submit
                              </button>
                            </div>{" "}
                          </div>
                        ) : null}
                      </>
                    )}

                    {isReview && (
                      <div
                        className="action-itms full-drp flex-column"
                        id="review"
                      >
                        <div className="d-flex justify-content-between w-100">
                          <div
                            className="hd-can-review create-form-wrp newPad px-4 "
                            style={{ width: "100%" }}
                          >
                            <h4>
                              <img
                                src={clientReview === null ? circle : success}
                                alt="copy"
                                className="create-icon mb-0 me-2"
                              />
                              Review & Confirm
                            </h4>
                            <p className=" pb-0 mt-3 review-texts">
                              Please review and sign below, acknowledging that
                              the documents are properly filled out and
                              compliant with state and federal law.
                            </p>
                            <div className="line-under"></div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                style={{
                                  border:
                                    isError === true && isConcent === false
                                      ? "1px solid red"
                                      : null,
                                }}
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                                checked={isConcent}
                                onChange={() => {
                                  setIsConsent(!isConcent);
                                }}
                              />
                              <label
                                className="form-check-label check-tetxz"
                                htmlFor="flexCheckDefault"
                              >
                                I hereby consent to electronically sign and
                                accept that onboarding forms were completed
                                accurately.
                              </label>
                            </div>

                            <div className="col-lg-4">
                              <div className="form-floating minH mb-5">
                                <input
                                  type="text"
                                  style={{
                                    border:
                                      isError === true && reviewerName === ""
                                        ? "1px solid red"
                                        : null,
                                  }}
                                  className="form-control signs"
                                  id="signHereInput"
                                  placeholder="name@example.com"
                                  value={reviewerName}
                                  onChange={(e) => {
                                    setReviewerName(e.target.value);
                                  }}
                                />
                                <label
                                  htmlFor="signHereInput"
                                  className=" font-enter-color"
                                >
                                  Sign Here
                                </label>
                              </div>
                            </div>

                            <div className="butnSpace">
                              <div className="col-lg-12">
                                <div className="q-btns my-3 d-flex justify-content-end">
                                  <button
                                    className="confirm-btn rounded p-2"
                                    style={{
                                      background:
                                        clientReview !== null && "grey",
                                    }}
                                    onClick={() => {
                                      clientReview === null &&
                                        reviewCandidate();
                                    }}
                                  >
                                    Confirm{" "}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                <div className="grid h-screen place-items-center ">
                  <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                  >
                    <div className="modal-width">
                      <h2 className="text-right text-xl modal-text">
                        <img
                          src={Alert}
                          alt="copy"
                          className="create-icon mb-0 me-2"
                        />
                        {modalData?.item === "section"
                          ? "Reset Section"
                          : "Restart Form"}
                      </h2>

                      <button onClick={closeModal} className="modal-close">
                        {" "}
                        <img
                          src={closex}
                          alt="copy"
                          className="create-icon mb-0 me-2"
                        />
                      </button>
                      <hr />
                      <div className="modal-text1">
                        By restarting {modalData?.itemName}, Candidate will need
                        to refill this {modalData.item}. Are you sure you want
                        to proceed?
                      </div>

                      <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
                        {modalData.item === "section" ? (
                          <button
                            className="yes-btn rounded p-2"
                            onClick={() => {
                              resetSection(modalData.data);
                            }}
                          >
                            {" "}
                            Yes{" "}
                          </button>
                        ) : (
                          <button
                            className="yes-btn rounded p-2"
                            onClick={() => {
                              resetForm(modalData.data);
                            }}
                          >
                            {" "}
                            Yes{" "}
                          </button>
                        )}
                        <p className="cancel-bttn" onClick={closeModal}>
                          {" "}
                          Cancel{" "}
                        </p>
                      </div>
                    </div>
                  </Modal>
                </div>

                <div className="grid h-screen place-items-center ">
                  <Modal
                    isOpen={showResetModal}
                    onRequestClose={() => {
                      setShowResetModal(false);
                    }}
                    style={customStyles}
                    contentLabel="Example Modal"
                  >
                    <div className="modal-width">
                      <h2 className="text-right text-xl modal-text">
                        <img
                          src={Alert}
                          alt="copy"
                          className="create-icon mb-0 me-2"
                        />
                        Restart progress?
                      </h2>
                      <button
                        onClick={() => {
                          setShowResetModal(false);
                        }}
                        className="modal-close"
                      >
                        <img src={closex} alt="close" className="close-icon" />
                      </button>
                      <hr />
                      <div className="modal-text1 text-marg">
                        By this action, Candidate will need to refill all the
                        forms. Any personalisation done will be reset to default
                        template. Are you sure you want to proceed?
                      </div>

                      <div className=" modal-check-bttn">
                        <div>
                          <div class="col-lg-12 px-1 mb-4">
                            <div class="form-group mt-0 mb-2 alertField">
                              <label class="form-label job-text mb-1">
                                Select Onboarding template:
                              </label>
                              <div class="select">
                                <select
                                  class="form-select "
                                  onChange={(e) => {
                                    setTemplateId(e.target.value);
                                  }}
                                >
                                  <option value="0">Select</option>
                                  {onboardingTemplates.map((item) => {
                                    return (
                                      <option value={item?.id}>
                                        {item?.template_name}
                                      </option>
                                    );
                                  })}
                                </select>
                                <i className="mt-3">
                                  <small>
                                    Selection is not necessary if you wish to
                                    send the onboarding set for this job.
                                  </small>
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="q-btns mt-0 mb-3 d-flex justify-content-end modal-bttn footer-bttn">
                        <div className="form-check me-3 ms-2 ps-0"></div>
                        <button
                          className="yes-btn rounded p-2"
                          onClick={() => resetOnboarding()}
                        >
                          Yes
                        </button>
                        <p
                          className="cancel-bttn ms-2"
                          onClick={() => {
                            setShowResetModal(false);
                          }}
                        >
                          Cancel
                        </p>
                      </div>
                    </div>
                  </Modal>
                </div>
              </>
            )}
          </div>

          <div className="grid h-screen place-items-center ">
            <Modal
              isOpen={overrideModal}
              onRequestClose={() => {
                setOverrideModal(false);
              }}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <div className="modal-width">
                <h2 className="text-right text-xl modal-text">
                  <img
                    src={Alert}
                    alt="copy"
                    className="create-icon mb-0 me-2"
                  />
                  Override onboarding
                </h2>
                <button
                  onClick={() => {
                    setOverrideModal(false);
                  }}
                  className="modal-close"
                >
                  <img src={closex} alt="close" className="close-icon" />
                </button>
                <hr />
                <div className="modal-text1 text-marg">
                  By overriding the current onboarding paperwork, the applicant
                  will no longer be able to complete anymore paperwork and be
                  marked as approved. Are you sure you want to proceed?
                </div>
                <div className="row">
                  <div className="col-lg-12 mb-12">
                    <div
                      className="form-floating wraper minH mb-3 over-ride"
                      style={{ position: "absolute; margin-left: 25px;" }}
                    >
                      <input
                        type="text"
                        className="form-control text-inputsz"
                        onChange={(e) => {
                          setReason(e.target.value);
                        }}
                        placeholder="Reason for override"
                      />
                      <label
                        htmlFor="signHereInput"
                        className=" font-enter-color"
                      >
                        Reason for override
                      </label>
                    </div>
                  </div>
                </div>
                <div className="q-btns mt-0 mb-3 d-flex justify-content-end modal-bttn footer-bttn">
                  <div class="col-sm-6" style={{ width: "67%;" }}></div>
                  <button
                    className="yes-btn rounded p-2"
                    onClick={() => overrideForm()}
                  >
                    Yes
                  </button>
                  <p
                    className="cancel-bttn ms-2"
                    onClick={() => {
                      setOverrideModal(false);
                    }}
                  >
                    Cancel
                  </p>
                </div>
              </div>
            </Modal>
          </div>
          {/* for showing toast */}
          <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          {loader && <Spinner />}
        </div>
      ) : (
        <div>
          <div className="fixHeader candPrv">
            <div className="row">
              <div className="w-100 logo-sec">
                <div className="logoCent logo-sec">
                  {companyLogo !== null && (
                    <img
                      src={API.avenuView + companyLogo}
                      alt="logo"
                      className="logo-inner mb-0 me-2"
                    />
                  )}
                </div>
                <div className="logoSide logo-sec">
                  <p className="Powered-by-text">Powered by</p>
                  <img
                    src={LogoPw}
                    alt="copy"
                    className="logo-inner mb-0 me-2"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="thanku-cards has-text-centered is-wide">
            <div className="card-1">
              <h4 class="thanku-text">
                <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
                {message}
              </h4>
              <p className="thanku-sub-heading">
                {message} Please reach out to your employer for additional
                details.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CandidateOnboardingForm;
